<template>
  <div class="custom-input" :class="wrapperClass">
    <input
      :type="computedType"
      :name="name"
      :placeholder="' '"
      :value="value"
      @input="noSpaceInput"
      @blur="$emit('blur')"
      :class="{ error: hasError }"
      :data-qa="dataQa"
      :autocomplete="autocomplete"
    />
    <label>{{ label }}</label>

    <!-- Eye button for password fields -->
    <button
      v-if="type === 'password'"
      type="button"
      class="custom-btn btn-eye"
      @click="togglePassword"
    >
      <i class="material-icons">
        {{ showPassword ? 'visibility_off' : 'visibility' }}
      </i>
    </button>

    <!-- Error message only shown for password complexity -->
    <span v-if="type === 'password' && hasError" class="help is-danger">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'InputField',

  props: {
    // Input props
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    validation: {
      type: String,
      default: ''
    },

    scope: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },

    // Optional props
    wrapperClass: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },

  data() {
    return {
      showPassword: false
    }
  },

  computed: {
    computedType() {
      if (this.type === 'password') {
        return this.showPassword ? 'text' : 'password'
      }
      return this.type
    },

    hasError() {
      return Boolean(this.error)
    },

    errorMessage() {
      return this.error
    }
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },

    noSpaceInput(event) {
      let value = event.target.value
      const cleanedvalue = value.replace(/\s/g, '')
      this.$emit('input', cleanedvalue)
    }
  }
}
</script>
